import {useDateTime} from '@hconnect/tuc-processes/fields/dateTime/useDateTime'
import {useLoadSpacing} from '@hconnect/tuc-processes/fields/loadSpacing'
import {useMix} from '@hconnect/tuc-processes/fields/mix/useMix'
import {usePlusLoadExpected} from '@hconnect/tuc-processes/fields/plusLoad/usePlusLoadExpected'
import {useQuantity} from '@hconnect/tuc-processes/fields/quantity/useQuantity'
import {useUnloadingMethod} from '@hconnect/tuc-processes/fields/unloadingMethod/useUnloadingMethod'
import React from 'react'

import {useSlotValidation} from '../components/fields/Time/useSlotValidation'
import {getTimeRelatedParams} from '../utils/timeRelatedParams'

interface ValidationProps {
  jobSite: {
    siteNumber?: string
    orgUnitId?: string
  } | null
}

export const useOrderEditSlotValidation = ({jobSite}: ValidationProps) => {
  const quantityReturn = useQuantity()
  // In quantity mode use exact m³, in fullLoads mode use minQuantity for slot validation
  const quantity =
    quantityReturn.type === 'volume' ? quantityReturn.volume : quantityReturn.minQuantity
  const {plusLoad} = usePlusLoadExpected()
  const {selectedUnloadingMethod} = useUnloadingMethod()
  const {timeOnJobSite, spacingOrFlowRate} = useLoadSpacing()
  const {dateTime} = useDateTime()
  const {selectedMaterial, selectedContract} = useMix()

  const slotAffectingParams = React.useMemo(() => {
    const timeRelatedParams = getTimeRelatedParams(timeOnJobSite, spacingOrFlowRate)

    const slotTimeParams: {
      loadSpacing?: string
      flowRate?: string
      totalTimeOnJobSite?: string
    } = {}

    if (timeRelatedParams.timeOnJobSite) {
      slotTimeParams.totalTimeOnJobSite = timeRelatedParams.timeOnJobSite
    }
    if (timeRelatedParams.loadSpace) {
      slotTimeParams.loadSpacing = timeRelatedParams.loadSpace
    }
    if (timeRelatedParams.flowRate) {
      slotTimeParams.flowRate = timeRelatedParams.flowRate.toString()
    }

    // we should check nullability first for all params probably
    return {
      contractNumber: selectedContract?.contractNumber || '',
      contractItemNumber: selectedMaterial?.contractItemPositionNumber || '',
      siteNumber: jobSite?.siteNumber || '',
      quantity: quantity,
      plusLoadExpected: plusLoad,
      unloadingMethod: selectedUnloadingMethod || '',
      orgUnitId: jobSite?.orgUnitId || '',
      ...slotTimeParams
    }
  }, [
    selectedContract?.contractNumber,
    jobSite?.orgUnitId,
    jobSite?.siteNumber,
    selectedMaterial?.contractItemPositionNumber,
    plusLoad,
    quantity,
    spacingOrFlowRate,
    timeOnJobSite,
    selectedUnloadingMethod
  ])

  const orderEditSlotValidation = useSlotValidation(dateTime?.[0], slotAffectingParams)

  return {
    orderEditSlotValidation
  }
}
